(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/reducers/compressed-coupon-reducer.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/reducers/compressed-coupon-reducer.js');
"use strict";

const _RTK = RTK,
  createReducer = _RTK.createReducer;
const _svs$components$tipse = svs.components.tipsen.store.actions.couponSettingsActions,
  setShowCompressedCoupon = _svs$components$tipse.setShowCompressedCoupon,
  setShowCompressedCouponResult = _svs$components$tipse.setShowCompressedCouponResult,
  setShowCompressedCouponMyBets = _svs$components$tipse.setShowCompressedCouponMyBets;
const compressedCouponReducer = createReducer({}, builder => {
  builder.addCase(setShowCompressedCoupon, (state, action) => {
    state[action.payload.moduleName].show = action.payload.show;
  });
  builder.addCase(setShowCompressedCouponResult, (state, action) => {
    state[action.payload.moduleName].show = action.payload.show;
  });
  builder.addCase(setShowCompressedCouponMyBets, (state, action) => {
    state[action.payload.moduleName].show = action.payload.show;
  });
});
setGlobal('svs.components.tipsen.store.reducers.compressedCouponReducer', compressedCouponReducer);

 })(window);